import { normalizeText } from "./geoText";

/**
 * Zwraca URL slug schroniska. Preferuje czystą kolumnę `slug` z bazy danych
 * (np. `warszawa-na-paluchu` lub `warszawa-na-paluchu-2` przy duplikatach).
 *
 * Fallback dla schronisk bez slug-a (lub w testach) – generuje slug z 8-znakowym
 * fragmentem ID, kompatybilny ze starszymi linkami.
 */
export const buildShelterSlug = (shelter: {
  id: string;
  name: string;
  city: string;
  slug?: string | null;
}): string => {
  if (shelter.slug && shelter.slug.length > 0) return shelter.slug;

  // Fallback (np. testy / brakujący slug)
  const slugify = (s: string) =>
    normalizeText(s)
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 60);
  const city = slugify(shelter.city);
  const name = slugify(shelter.name);
  const shortId = shelter.id.replace(/-/g, "").slice(0, 8);
  return [city, name, shortId].filter(Boolean).join("-");
};

/**
 * Wyciąga 8-znakowy fragment ID z końca slug-a (kompatybilność ze starymi
 * linkami w formacie `miasto-nazwa-a3f9b21c`).
 */
export const extractIdFromSlug = (slug: string): string | null => {
  const parts = slug.split("-");
  const last = parts[parts.length - 1];
  if (!last || last.length !== 8 || !/^[a-f0-9]+$/i.test(last)) return null;
  return last.toLowerCase();
};

/**
 * Czy pełny UUID pasuje do shortId ze sluga.
 */
export const matchesShortId = (fullId: string, shortId: string): boolean => {
  return fullId.replace(/-/g, "").slice(0, 8).toLowerCase() === shortId.toLowerCase();
};

export const shelterUrl = (shelter: { id: string; name: string; city: string; slug?: string | null }): string =>
  `/schronisko/${buildShelterSlug(shelter)}`;
